import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Company, CompanyFromSiret, CompanyLogo, CompanySecure } from '@models/company/company';
import { ErrorSiret } from '@models/company/company-error';
import { CompanyNumbers } from '@models/company/company-numbers';
import { CreateImmersion, CreateImmersionResponse } from '@models/company/create-immersion';
import { ErrorApi } from '@models/error-api';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CompanyWebservice {
  constructor(private readonly http: HttpClient) {}

  // tslint:disable: no-duplicate-string
  get(companyId: string): Observable<Company> {
    return this.http.get<Company>(`${environment.api.company}/api/company/${companyId}`);
  }

  create(payload: any): Observable<CompanySecure> {
    return this.http.post<CompanySecure>(`${environment.api.company}/api/public/company`, payload);
  }

  getTotalRecruit(): Observable<CompanyNumbers> {
    return this.http.get<CompanyNumbers>(`${environment.api.company}/api/public/total_recruit`);
  }

  getLogos(): Observable<CompanyLogo[]> {
    return this.http.get<CompanyLogo[]>(`${environment.api.company}/api/logos`);
  }

  getCompanyFromSiretCode(siret: string): Observable<CompanyFromSiret> {
    return this.http.get<CompanyFromSiret>(`${environment.api.company}/api/company/siret/${siret}`);
  }

  getSecure(token: string): Observable<CompanySecure> {
    return this.http.get<CompanySecure>(`${environment.api.company}/api/self/company`, {
      headers: {
        'X-AUTH-TOKEN': token,
      },
    });
  }

  updateSecure(token: string, payload: any): Observable<CompanySecure> {
    return this.http
      .put<CompanySecure>(`${environment.api.company}/api/self/company`, payload, {
        headers: {
          'X-AUTH-TOKEN': token,
        },
      })
      .pipe(
        catchError((errorApi: ErrorApi) => {
          const error = errorApi.error;
          const isSiretError = error.violations.filter(
            (e) => e.title.includes('The siret') && e.title.includes('is already registred')
          );
          if (isSiretError) {
            return throwError(new ErrorSiret('Ce SIRET est déjà utilisé par une entreprise'));
          }

          return throwError(errorApi);
        })
      );
  }

  createImmersion(createImmersion: CreateImmersion): Observable<CreateImmersionResponse> {
    return this.http.post<CreateImmersionResponse>(`${environment.api.company}/v1/immersion`, createImmersion);
  }
}
